import React from 'react';
import axios from 'axios';
import { format, subMonths } from 'date-fns';
import { ru } from 'date-fns/locale';

import Balance from '../Components/Balance';
import UsersCase from '../Components/UsersCase';

import { useModal } from './Modal/ModalContext';
import { useTimeModal } from './TimeModal/TimeModalContext';
import { formatDateTime } from '../Utils/GlobalUtils';

import Loading from './Loading';

import styles from '../styles/DynamicModal.module.css';

const CardOfUser = ({ closeModal, id, onCardOfAMSuccess, isPage }) => {
    const { openModal } = useModal();
    const { openTimeModal } = useTimeModal();

    const [user, setUser] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);

    const currentMonth = format(new Date(), 'LLLL', { locale: ru });
    const prevMonth = format(subMonths(new Date(), 1), 'LLLL', { locale: ru });
    const prevPrevMonth = format(subMonths(new Date(), 2), 'LLLL', { locale: ru });

    React.useEffect(() => {
        document.body.style.overflow = 'hidden';
    
        return () => {
            document.body.style.overflow = '';
        };
    }, []);


    React.useEffect(() => {
        const token = localStorage.getItem('token');
        setLoading(true);
        axios.get(`/api/get-full-info-user?id=${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            if (response.data.length === 0) {
                setWarning('Ошибка системы.');
            } else {
                setWarning('');
                setUser(response.data);
                document.title = `${response.data.lastname + ' ' + response.data.firstname + ' ' + response.data.surname} — Журнал «Поток»`;
            }
        })
        .catch(error => {
            setWarning('Ошибка получения данных: '+error.response.data.message || error.message);
        })
        .finally(() => {
            setReload(false);
            setLoading(false);
        });
    }, [reload, id]);

    const deleteUser = (userIdForDelete) => {
        const token = localStorage.getItem('token');

        axios.put(`/api/block-unblock-acc?userId=${userIdForDelete}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(() => {
            setReload(true);
            openTimeModal(`Учётная запись деактивирована`, 'success');
            onCardOfAMSuccess();
        })
        .catch(error => {
            console.error('Ошибка при деактивации учётной записи пользователя:', error);
            openTimeModal(`Не удалось деактивировать учётную запись. ${error.response?.data.message || error.message}`, 'error');
        });
    };

    const changeAccess = (userIdForChange) => {
        axios.put(`/api/change-access?userId=${userIdForChange}`)
        .then((response) => {
            setReload(true);
            if (response.data == 'На рассмотрении') {
                openTimeModal('Доступ отозван', 'success');
            } else {
                openTimeModal('Доступ разрешён', 'success');
            }
            onCardOfAMSuccess();
        })
        .catch(error => {
            console.error('Ошибка при изменении доступа:', error);
            openTimeModal(`Не удалось изменить параметр доступа к системе. ${error.response?.data.message || error.message}`, 'error');
        })
    };

    const warningChangeStatus = 
    <form style={{textAlign: 'center'}}>
        <h3>Внимание,</h3>
        <a style={{cursor: 'text', fontSize: '16px'}}>В целях безопасности системы вы не можете отозвать доступ у своей учётной записи. Обратитесь к администратору.</a>
    </form>;

    const getTitle = () => {
        if (loading) {
            return 'Загрузка карточки...';
        }
        switch (user.role) {
            case 'Арбитражный управляющий':
                return 'Карточка арбитражного управляющего';
            case 'Администратор':
                return 'Карточка администратора';
            case 'Менеджер':
                return 'Карточка менеджера';
            case 'Работник по назначениям':
                return 'Карточка работника по назначениям';
            case 'Работник по жалобам':
                return 'Карточка работника по жалобам';
            case 'Работник по общим':
                return 'Карточка работника по общим';
            default:
                return 'Карточка пользователя';
        }
    };

    return (
    <>
        <div className={styles.liningOver} onClick={!isPage ? () => { closeModal(); } : undefined} style={isPage ? { backgroundColor: '#00000000' } : undefined}>
            <form className={styles.lining} onClick={(e) => e.stopPropagation()}>
            <div className={styles.header}>
                <h1>{getTitle()}</h1>
                <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                </svg>
            </div>
            <div className={styles.main}>
                {loading ? (
                 <Loading />
                ) : warning ? (
                    <a>{warning}</a>
                ) : (
                    <>
                        <div className={styles.cardOfCaseLine}>
                            <h2>ФИО:</h2>
                            <a>{user.lastname} {user.firstname} {user.surname}</a>
                        </div>
                        <div className={styles.cardOfCaseLine}>
                            <h2>Адрес электронной почты:</h2>
                            <a href={`mailto:${user.email}`} className={styles.aWithLink}>{user.email}</a>
                        </div>
                        <div className={styles.cardOfCaseLine}>
                            <h2>Тип учётной записи:</h2>
                            <a>{user.role}</a>
                        </div>
                        <div className={styles.cardOfCaseLine}>
                            <h2>Основной регион деятельности:</h2>
                            <a>{user.region}</a>
                        </div>
                        <div className={styles.cardOfCaseLine}>
                            <h2>Счёт:</h2>
                            <a>{user.balance + ' ₽'}</a>
                            <Balance userId={user.id} onSuccess={() => {setReload(true)}} />
                        </div>
                        <div className={styles.cardOfCaseLine}>
                            <h2>Статус аккаунта:</h2>
                            <a>{user.approval}</a>
                        </div>
                        <div className={styles.cardOfCaseLine}>
                            <h2>Дата и время создания учётной записи:</h2>
                            <a>{formatDateTime(user.created_at)}</a>
                        </div>

                            <div className={styles.limitLine}></div>

                        <div className={styles.cardOfCaseLine}>
                            <h2>Количество назначений:</h2>
                            <a>за {currentMonth} - {user.numberOfAppointmentsCurMonth}</a>
                            <a>за {prevMonth} - {user.numberOfAppointmentsPrevMonth}</a>
                            <a>за {prevPrevMonth} - {user.numberOfAppointmentsPrevPrevMonth }</a>
                        </div>

                            <div className={styles.limitLine}></div>

                        <div className={styles.cardOfCaseLine}>
                            <UsersCase id={id} />
                        </div>

                            <div className={styles.limitLine}></div>

                        <div className={styles.cardOfCaseLine}>
                            {user.me ? (
                                <button type='button' className='button black unactive' onClick={() => openModal('Сообщение', warningChangeStatus)}>Отозвать доступ</button>
                            ) : user.approval == 'На рассмотрении' ? (
                                <>
                                    <button type='button' className='button' onClick={() => changeAccess(id)}>Выдать доступ</button>
                                    <button type='button' className='button black' onClick={() => deleteUser(id)}>Деактивировать учётную запись</button>
                                </>
                            ) : user.approval == 'Отключен' ? (
                                <button type='button' className='button black' onClick={() => deleteUser(id)}>Активировать учётную запись</button>
                            ) : (
                                <>
                                    <button type='button' className='button' onClick={() => changeAccess(id)}>Отозвать доступ</button>
                                </>
                            )}
                        </div>
                    </>
                )}
            </div>
            </form>
        </div>
    </>
    )
}

export default CardOfUser;